// frontend/src/services/api.js

import axios from 'axios';

// Define an API base URL
const API_BASE_URL = process.env.VUE_APP_API_URL || '/api';

// Function to get current language
function getCurrentLanguage() {
  return localStorage.getItem('locale') || 'en';
}

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Accept-Language': getCurrentLanguage()
  }
});

// Update Accept-Language header when locale changes
window.addEventListener('storage', (event) => {
  if (event.key === 'locale') {
    apiClient.defaults.headers['Accept-Language'] = getCurrentLanguage();
  }
});

// Add request interceptor for debugging
apiClient.interceptors.request.use(request => {
  // Make sure we always use the current language
  request.headers['Accept-Language'] = getCurrentLanguage();

  console.log('API Request:', {
    method: request.method,
    url: request.url,
    data: request.data,
    headers: request.headers
  });
  return request;
});

// Add response interceptor for debugging
apiClient.interceptors.response.use(
  response => {
    console.log('API Response:', {
      status: response.status,
      data: response.data,
      headers: response.headers
    });
    return response;
  },
  error => {
    console.error('API Error Response:', {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      } : 'No response'
    });
    return Promise.reject(error);
  }
);

export default apiClient;